module.exports = __webpack_public_path__ + "static/media/1.e185df84.jpg";